import { colors2, transition, UI_BODY_SM_DF } from "oolib";
import { ButtonPrimary } from "oolib/dist/v2/components/Buttons";
import React, { useState } from "react";
import styled from "styled-components";
import { allWidgetsBaseConfs, GRID_GAP, TOTAL_COLUMNS } from "../../CONFIG";
import { handleAddWidget } from "../../utils/handleAddWidget";

const StyledAddWidgetButtonWrapper = styled.div`
  ${transition("opacity")};
  opacity: 0;
  &:hover {
    opacity: 1;
  }
`;

const ToReplaceWithListComponent = ({ style = {}, onClick }) => {
  return (
    <div
      style={{
        ...style,
        background: colors2.white,
        minWidth: "100px",
        border: `1px solid ${colors2.grey10}`,
      }}
    >
      {allWidgetsBaseConfs.map((w, wI) => (
        <button
          style={{
            padding: "0.4rem 0.8rem",
            border: "none",
            borderBottom:
              wI !== allWidgetsBaseConfs.length - 1
                ? `1px solid ${colors2.grey10}`
                : "none",
            background: "none",
            cursor: "pointer",
            width: "100%",
            textWrap: "nowrap",
            textAlign: "left",
          }}
          onClick={() => onClick(w)}
        >
          <UI_BODY_SM_DF>{w.display}</UI_BODY_SM_DF>
        </button>
      ))}
    </div>
  );
};

export const AddWidgetButton = ({
  currentFirstWidgetInRow,
  widgetIndex,
  config,
  setConfig,
  setUnderEditWidgetIdx,
  isNewRow,
  style = {},
}) => {
  const [showList, setShowList] = useState(false);
  return (
    <StyledAddWidgetButtonWrapper>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: -GRID_GAP + "px",
          transform: "translateX(-100%)",
          zIndex: 100,
          ...style,
        }}
        // onMouseOut={() => setShowList(false)}
      >
        {showList && (
          <div
            style={{
              position: "absolute",
              paddingLeft: GRID_GAP + "px",
              right: 0,
              top: "50%",
              transform: "translate(100%)",
            }}
          >
            <ToReplaceWithListComponent
              onClick={(newWidgetBaseConf) => {
                const { newWidgetIdx } = handleAddWidget({
                  currentFirstWidgetInRow,
                  widgetIndex,
                  config,
                  setConfig,
                  isNewRow,
                  newWidgetBaseConf,
                  TOTAL_COLUMNS,
                });
                setUnderEditWidgetIdx(newWidgetIdx);
                setShowList(false);
              }}
            />
          </div>
        )}
        <ButtonPrimary
          onClick={() => setShowList((prev) => !prev)}
          S
          icon="Plus"
          style={{
            height: "100%",
            width: "2rem",
          }}
        />
      </div>
    </StyledAddWidgetButtonWrapper>
  );
};
